// @flow

import { connect } from 'react-redux';
import * as Selectors from '../selectors';
import { ORG_HAS_STAFF_DETECTION } from '../constants/features';
import SingleReportPage from '../components/pages/single-report';
import { getUrlHashAsObject } from '../utils/urlHelpers';
import { makeAmendmentsToReport } from '../utils/reports';
import { getOptions } from '../models/user';
import {
  deleteDashboardReport,
  shareDashboardReport,
} from '../actions/reports';
import { MY_REPORTS } from '../constants/routes';

function mapStateToProps(state, ownProps) {
  const { match, location } = ownProps;
  
  // Determine if we're in my-reports or org reports based on the route
  const isMyReports = match && match.path && match.path.includes(MY_REPORTS);

  const sourceReportData = Selectors.getOneReport(match.params.reportId, state);
  let startingReport = sourceReportData;

  if (location.hash) {
    try {
      const amendments = getUrlHashAsObject(location.hash);
      startingReport = makeAmendmentsToReport(sourceReportData, amendments);
    } catch (e) {
      console.error(
        "Couldn't make desired amends to report using the URL hash",
      );
    }
  }

  // Use sorted selectors to match sidebar ordering
  const allReports = isMyReports
    ? Selectors.getMyReports(state)
    : Selectors.getOrgReports(state);

  return {
    ...ownProps,
    allReports,
    startingReport,
    showStaffFilters: Selectors.userHasFeature(ORG_HAS_STAFF_DETECTION, state),
    allLocationsList: Selectors.getLocations(state),
    availableMetrics: Selectors.getAvailableMetrics(state),
    startOfWeek: getOptions(state.user.model).startOfWeek,
  };
}

export default connect(mapStateToProps, {
  deleteDashboardReport,
  shareDashboardReport,
})(SingleReportPage);
